module.exports = __webpack_public_path__ + "media/images/concept_design_award_participate_icon-w@2x-4827c869c03bbf6aa7064c4e28d04862.png";